import { useQuery } from "@tanstack/react-query";
import { getTargetareSetari } from "@/api/endpoints/targetareDate";
import { queryKeys } from "@/lib/queryClient";

export function useGetTargetareSetari() {
  return useQuery({
    queryKey: queryKeys.targetare.setari(),
    queryFn: getTargetareSetari,
    select: (response) => response.data,
    staleTime: 1000 * 60,
    retry: 1,
  });
}
